import ClassCard from './component'
export default ClassCard
